<app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
  (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink="">
</app-campaign-3-breadcrumb>
<!-- 🔍 Search -->
<div class="search-section">
  <h2>{{ 'challenge.challenge_search' | translate }}</h2>

  <form class="search-fields" (ngSubmit)="search()">

    <!-- RIGA 1: Challenge -->
    <div class="field-row">
      <div class="field-group">
        <app-form-fields #challengeField data-testid="challenge" [filterable]="true" [(fieldModel)]="searchChallenge"
          [type]="'dropdown'" [options]="challengeList" [name]="'challenge'" [optionLabel]="'display'"
          [placeholder]="'challenge.challenge_select_placeholder' | translate" [required]="true"
          [label]="'challenge.selectChallenge' | translate" (fieldModelChange)="onChallengeSelected()">
        </app-form-fields>

      </div>
    </div>

    <!-- RIGA 2: Date -->
    <div class="field-row">

      <!-- Data Inizio -->
      <div class="field-group"
        *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
        <app-form-fields #start_date_field data-testid="start_date_field" [label]="'challenge.start_date' | translate"
          [(fieldModel)]="searchDateStart" [type]="'date'" [required]="true"
          [placeholder]="'challenge.select_start_date' | translate">
        </app-form-fields>
      </div>

      <!-- Data Fine -->
      <div class="field-group"
        *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
        <app-form-fields #end_date_field data-testid="end_date_field" [label]="'challenge.end_date' | translate"
          [(fieldModel)]="searchEndDate" [type]="'date'" [required]="true" [maxDate]="maxEndDate"
          [placeholder]="'challenge.select_end_date' | translate">
        </app-form-fields>
      </div>

    </div>

    <!-- RIGA 3: Accumulatore + Frequenza -->
    <div class="field-row">

      <!-- Accumulatore -->
      <div class="field-group">
        <app-form-fields #acm_field *ngIf="readyAcm" data-testid="acm_field" [(fieldModel)]="selectedAcm"
          [type]="'dropdown'" [options]="acmList" [name]="'acm'" [optionLabel]="'label'"
          [placeholder]="'challenge.acm' | translate" [required]="true" [label]="'challenge.acm' | translate">
        </app-form-fields>
      </div>

      <!-- Frequenza -->
      <div class="field-group">
        <app-form-fields #sampleFrequencyField data-testid="sampleFrequencyField" [(fieldModel)]="sampleFrequency"
          [type]="'dropdown'" [options]="sampleFrenquencyList" [name]="'sampleFrequency'" [optionLabel]="'label'"
          [placeholder]="'challenge.sampleFrequency' | translate" [required]="true"
          [label]="'challenge.sampleFrequency' | translate" (fieldModelChange)="onFrequencySelected()">
        </app-form-fields>
      </div>

    </div>

    <!-- Bottone -->
    <button type="submit">
      {{ 'challenge.search' | translate }}
    </button>

  </form>
</div>


<!--  Results -->
<div *ngIf="dataLoaded" class="results-section">

  <div class="results-box">
    <div class="results-header">
      <h3>{{ 'challenge.ricerca' | translate }}</h3>

      <div class="toggle-container">
        <button type="button" class="toggle-btn" [ngClass]="{ 'active': showExclusive }" [disabled]="showExclusive"
          (click)="showOnlyExclusive()">
          {{ 'challenge.exclusive' | translate }}
        </button>

        <button type="button" class="toggle-btn" [ngClass]="{ 'active': !showExclusive }" [disabled]="!showExclusive"
          (click)="showOnlyInclusive()">
          {{ 'challenge.inclusive' | translate }}
        </button>
      </div>
    </div>

    <!--  Numeri -->
    <div class="results-numbers">
      <!-- Totale partecipanti -->
      <div class="card-number">
        <div class="label">{{ 'challenge.total_partecipant' | translate }}</div>
        <div class="value">{{ numericResults.totalPartecipant }}</div>
      </div>
      <!-- Partecipanti Che hanno accettato la sfida -->
      <div class="card-number">
        <div class="label">{{ 'challenge.effective_partecipant' | translate }}</div>

        <div class="value">
          {{ numericResults.effectivePartecipant }}
          {{ 'common.of' | translate }}
          {{ numericResults.totalPartecipant }}

          <span class="percentage">
            ({{ numericResults.effectivePercentage | number:'1.0-2' }}%)
          </span>
        </div>

        <div class="progress-bar">
          <div class="progress" [style.width.%]="numericResults.effectivePercentage">
          </div>
        </div>
      </div>
      <!-- Partecipanti con Movimenti -->
      <div class="card-number">
        <div class="label">{{ 'challenge.active_partecipant' | translate }}</div>
        <div class="value">



          {{ numericResults.activePartecipant }}
          {{ 'common.of' | translate }}
          {{ numericResults.effectivePartecipant }}

          <span class="percentage">({{ numericResults.activePartecipantPercentage | number:'1.0-2' }}%)</span>
        </div>
        <div class="progress-bar">
          <div class="progress" [style.width.%]="numericResults.activePartecipantPercentage"></div>
        </div>
      </div>
      <!-- LIVELLI EXCLUSIVE -->
      <div *ngIf="numericResults && showExclusive && !emptyLevels">
        <h1>{{ 'challenge.exclusive_levels' | translate }}</h1>
        <div class="card-level" *ngFor="let lvl of numericResults.levels">
          <div class="label">{{ lvl.title }}</div>
          <div class="value">
            {{ lvl.participants }} ({{ lvl.percentage | number:'1.0-2' }}%)
          </div>
          <div class="progress-bar">
            <div class="progress" [style.width.%]="lvl.percentage"></div>
          </div>
        </div>
      </div>

      <!-- LIVELLI INCLUSIVE -->
      <div *ngIf="numericResults && !showExclusive && !emptyLevels">
        <h1>{{'challenge.inclusive_levels' | translate }}</h1>
        <div class="card-level" *ngFor="let lvl of numericResults.inclusiveLevels">
          <div class="label">{{ lvl.title }}</div>
          <div class="value">
            {{ lvl.participants }} ({{ lvl.percentage | number:'1.0-2' }}%)
          </div>
          <div class="progress-bar">
            <div class="progress" [style.width.%]="lvl.percentage"></div>
          </div>
        </div>
      </div>




    </div>
    <div *ngIf="emptyLevels">
      {{ 'challenge.no_data_levels' | translate }}
    </div>

    <div class="download-button-section">
      <button pButton type="button" [label]="'challenge.exportPartecipant' | translate" icon="pi pi-download"
        (click)="onExportParticipants()" data-testid="export-participants">
      </button>
    </div>


    <!-- Grafici -->
    <div class="results-graphics">


      <div class="results-chart-box">
        <chart [options]="chartPie"></chart>
      </div>




      <div class="results-chart-box">
        <chart [options]="chartCartesian"></chart>
      </div>


    </div>
  </div>





</div>




  <div class="ui-g-12" *ngIf="showTableExport">

    <div class="header-row" *ngIf="showTableExport">
      <h1 class="title" style="margin:5px">
        {{ 'challenge.challenge_graphics_details_exports' | translate }}
      </h1>
    </div>

    <app-campaign-3-kontable #excellReportTable *ngIf="showTableExport" [columns]="[
      {
      field: 'id',
      title: 'challenge.idReport',
      filterType: textFilter
    },
     {
      field: 'fileName',
      title: 'challenge.fileName',
      filterType: textFilter,
      bodyTemplate: fileNameTemplate

    },
    {
      field: 'challengeId',
      title: 'challenge.challengeId',
      filterType: textFilter
    },
     
    {
      field: 'queryCondition',
      title: 'challenge.queryCondition',
      filterType: textFilter
    },
    {
      field: 'mineType',
      title: 'challenge.mineType',
      filterType: textFilter
    },
    {
      field: 'reportState',
      title: 'challenge.reportState',
      filterType: selectFilter,
      filterOptions: { values: reportStateList },
      bodyTemplate: reportStatesTemplate
    },
    {
      field: 'queryCount',
      title: 'challenge.queryCount',
      filterType: textFilter
    },
    {
      field: 'creationDate',
      title: 'challenge.creationDate',
      filterType: dateFilter,
      bodyTemplate: dateTemplate 
    }

  ]" [service]="challengeOverviewExportGraphicService" [paginationType]="paginationType" [showRecoverButton]="false"
      [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
      [showEditButton]="false" [filterBySingleColumn]="true" [additionalRowCommands]="actions"
      [showGlobalFilter]="false" [expandTable]="false" [showDownloadExcelBtn]="false" [subjectToLoad]="pageSubject"
      [showRowButtons]="true">

      <ng-template #fileNameTemplate let-row>
        <span [title]="row.fileName">
          {{ getFileName(row.fileName) }}
        </span>
      </ng-template>

      <ng-template #reportStatesTemplate let-row>
        <span [title]="row.fileName">
          {{ getReportStatus(row.reportState) }}
        </span>
      </ng-template>


      <ng-template #dateTemplate let-row>
        <span>{{
          row.creationDate |
          date:srvCalendar.pcalendarTranslate.dateFormatFilter
          }}</span>
      </ng-template>

      <!-- Azioni riga -->
      <ng-template #actions let-row>

        <div class="d-flex justify-content-center">


          <button class="roundedButton row-buttom-margin" pTooltip="{{ 'common.actions' | translate }}"
            data-testid-generic="challengeActions" [attr.data-testid]="'challengeActions' + row.id"
            (click)="toggleMenu(row)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>

          <!-- error log -->
          <div *ngIf="this.exportErrorPermission">
            <button class="roundedButton" pTooltip="{{ 'common.actions' | translate }}"
              data-testid-generic="challengeActions" [attr.data-testid]="'challengeActions' + row.id"
              (click)="infoErrorExport(row)">
              <i class="pi pi-info-circle icon-size"></i>
            </button>
          </div>
        </div>

        <!-- Dropdown azioni -->
        <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">


          <!-- publish -->
          <button class="dropdown-item-creation" data-testid-generic="obtainReport" [disabled]="row.reportState != 1"
            (click)="obtainReport(row)">
            {{ 'challenge.obtain_report' | translate }}
          </button>

          <button class="dropdown-item-creation" data-testid-generic="deleteReport" [disabled]="row.reportState === 0"
            (click)="deleteReport(row)">
            {{ 'challenge.delete_report' | translate }}
          </button>




        </div>

      </ng-template>


    </app-campaign-3-kontable>


    


  </div>

    <!-- Popup cancellazione -->
  <p-dialog class="custom-dialog" header="{{ 'challenge.confirm_delete_report' | translate }}"
    [(visible)]="displayDeleteDialog" [modal]="true" [closable]="false">

    <div>
      {{ 'challenge.confirm_delete_message_report' | translate }}
    </div>

    <div class="custom-footer">
      <button type="button" pButton icon="pi pi-times" label="{{ 'common.cancel' | translate }}"
        (click)="closePopupDelete()">
      </button>

      <button type="button" pButton icon="pi pi-check" label="{{ 'common.confirm' | translate }}"
        style="margin-left: .25em" (click)="onDefinitiveDelete(reportToDelete)">
      </button>
    </div>

  </p-dialog>

  <div *ngIf="showPopupInfoDownload">
    <p-dialog header="{{ 'challenge.detailDownload' | translate }}" [(visible)]="showPopupInfoDownload" [modal]="true"
      [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfoDownload()">
      <pre>{{ 'challenge.msgDetailDownload' | translate }}</pre>
    </p-dialog>
  </div>

  <div *ngIf="showPopupInfoErrorExport">
    <p-dialog header="{{ 'challenge.msgDetailErrorExport' | translate }}" [(visible)]="showPopupInfoErrorExport"
      [modal]="true" [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfoErrorExport()">
      <pre>{{reportError}}</pre>
    </p-dialog>
  </div>



// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-graphics/challenge-graphics.component.html